import { FC } from 'react';

import { TooltipProps } from 'recharts';

import { Card } from 'components/ui/card';

type PieChartTooltipProps = TooltipProps<number, string>;

export const PieChartTooltip: FC<PieChartTooltipProps> = ({
  active,
  payload,
  label
}) => {
  const value = payload?.[0]?.payload?.breakdownValue;
  return (
    <Card className="flex flex-col py-2 px-4 items-start gap-1 rounded-md border border-base-popover bg-base-popover shadow-md">
      <p className="text-base-popoverForeground text-p-xs">{value}</p>
    </Card>
  );
};
